<script setup>
import { ref } from 'vue';

import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';
import WahaCampaignContactsDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/WahaCampaign/WahaCampaignContactsDialog.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['delete']);

const contactsDialogRef = ref(null);
const selectedCampaign = ref(null);

const handleDelete = campaign => emit('delete', campaign);

const handleViewContacts = campaign => {
  selectedCampaign.value = campaign;
  contactsDialogRef.value?.open();
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :status="campaign.campaign_status"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :message-delay="campaign.message_delay"
      :delay-unit="campaign.delay_unit"
      :delay-variation-percent="campaign.delay_variation_percent"
      :prevent-duplicate-contacts="campaign.prevent_duplicate_contacts"
      :auto-enqueue-by-label="campaign.auto_enqueue_by_label"
      is-waha-type
      @delete="handleDelete(campaign)"
      @view-contacts="handleViewContacts(campaign)"
    />
  </div>
  <WahaCampaignContactsDialog
    ref="contactsDialogRef"
    :campaign="selectedCampaign"
  />
</template>
